<template>
    <v-container fluid>
        <v-row class="align-center mb-2">
            <v-col cols="auto" class="d-flex align-center">
                <v-btn icon variant="text" class="mr-1" @click="tornaIndietro">
                    <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                <h2 class="text-h6">Tipi incasso</h2>
            </v-col>
            <v-spacer />
            <v-col cols="auto">
                <v-btn color="primary" prepend-icon="mdi-plus" @click="apriDialog(null)">Nuovo tipo</v-btn>
            </v-col>
        </v-row>

        <v-data-table :headers="headers" :items="lista" :items-per-page="15" density="comfortable">
            <template #[`item.colore`]="{ item }">
                <v-chip size="small" :color="item.colore || 'grey'" variant="flat">&nbsp;</v-chip>
            </template>
            <template #[`item.frequenza`]="{ item }">
                <span v-if="item.frequenzaValore">ogni {{ item.frequenzaValore }} {{ etichettaUnita(item.frequenzaUnita)
                }}</span>
                <span v-else class="text-medium-emphasis">manuale</span>
            </template>
            <template #[`item.azioni`]="{ item }">
                <v-btn icon variant="text" size="small" title="Duplica" @click="duplica(item)">
                    <v-icon>mdi-content-copy</v-icon>
                </v-btn>
                <v-btn icon variant="text" size="small" @click="apriDialog(item)">
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon variant="text" size="small" color="error" @click="elimina(item)">
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
            </template>
        </v-data-table>

        <v-dialog v-model="dialog" max-width="480">
            <v-card>
                <v-card-title>{{ form.id ? 'Modifica tipo incasso' : 'Nuovo tipo incasso' }}</v-card-title>
                <v-card-text>
                    <v-form ref="formRef">
                        <v-text-field v-model="form.nome" label="Nome" :rules="[v => !!v || 'Obbligatorio']" />
                        <v-textarea v-model="form.descrizione" label="Descrizione" rows="2" />
                        <v-row>
                            <v-col cols="6">
                                <v-text-field v-model.number="form.frequenzaValore" type="number"
                                    label="Frequenza (numero)" hint="Vuoto = solo manuale" persistent-hint />
                            </v-col>
                            <v-col cols="6">
                                <v-select v-model="form.frequenzaUnita" :items="unitaDisponibili" item-title="label"
                                    item-value="value" label="Unità" clearable />
                            </v-col>
                        </v-row>
                        <colore-picker-field v-model="form.colore" label="Colore calendario" />

                        <v-divider class="my-4" />
                        <div class="text-caption text-medium-emphasis mb-2">Promemoria scadenza</div>
                        <v-row>
                            <v-col cols="6">
                                <v-text-field v-model.number="form.giorniPreavviso" type="number"
                                    label="Giorni di preavviso" :rules="[v => v >= 0 || 'Non può essere negativo']" />
                            </v-col>
                            <v-col cols="6" class="d-flex align-center">
                                <v-switch v-model="form.notificheAttive" label="Notifiche attive" color="primary"
                                    hide-details />
                            </v-col>
                        </v-row>
                        <v-text-field v-model="form.emailDestinatariAggiuntivi" label="Email aggiuntive (separate da virgola)"
                            hint="Oltre agli Admin (gli Incassi sono riservati a loro)" persistent-hint />
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="dialog = false">Annulla</v-btn>
                    <v-btn color="primary" @click="salva">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { get_impostazioni_notifiche, salva_impostazioni_notifiche } from "@/api/api.impostazioniNotifiche.js";
import ColorePickerField from "@/components/common/ColorePickerField.vue";

export default {
    name: "TipiIncassoPage",

    components: { ColorePickerField },

    data() {
        return {
            dialog: false,
            form: this.formVuoto(),
            headers: [
                { title: "Colore", key: "colore", sortable: false },
                { title: "Nome", key: "nome" },
                { title: "Descrizione", key: "descrizione" },
                { title: "Frequenza", key: "frequenza", sortable: false },
                { title: "", key: "azioni", sortable: false },
            ],
            // Il backend serializza FrequenzaUnita come stringa (JsonStringEnumConverter):
            // i value corrispondono ai nomi dei membri dell'enum UnitaFrequenza.
            unitaDisponibili: [
                { label: "Giorni", value: "Giorni" },
                { label: "Settimane", value: "Settimane" },
                { label: "Mesi", value: "Mesi" },
                { label: "Anni", value: "Anni" },
            ],
        };
    },

    computed: {
        lista() {
            return this.$store.getters["tipiIncasso/lista"];
        },
    },

    mounted() {
        this.$store.dispatch("tipiIncasso/carica");
    },

    methods: {
        tornaIndietro() {
            this.$router.push("/incassi");
        },

        formVuoto() {
            return {
                id: null, nome: "", descrizione: "", frequenzaValore: null, frequenzaUnita: null, colore: "",
                giorniPreavviso: 7, notificheAttive: true, emailDestinatariAggiuntivi: "",
            };
        },

        async apriDialog(item) {
            this.form = item ? { ...this.formVuoto(), ...item } : this.formVuoto();
            this.dialog = true;
            if (item) {
                try {
                    const resp = await get_impostazioni_notifiche("Incasso", item.id);
                    this.form.giorniPreavviso = resp.data.giorniPreavviso;
                    this.form.notificheAttive = resp.data.attivo;
                    this.form.emailDestinatariAggiuntivi = resp.data.emailDestinatariAggiuntivi || "";
                } catch (error) {
                    console.log(error);
                }
            }
        },

        async salva() {
            if (!this.$refs.formRef.validate()) return;
            try {
                const { id, giorniPreavviso, notificheAttive, emailDestinatariAggiuntivi, ...dati } = this.form;
                const resp = await this.$store.dispatch("tipiIncasso/salva", { id, dati });
                const tipoId = id || resp.data.id;

                await salva_impostazioni_notifiche({
                    categoria: "Incasso",
                    tipoId,
                    giorniPreavviso,
                    attivo: notificheAttive,
                    emailDestinatariAggiuntivi,
                });

                this.dialog = false;
            } catch (error) {
                console.log(error);
            }
        },

        async elimina(item) {
            try {
                await this.$store.dispatch("tipiIncasso/elimina", item.id);
            } catch (error) {
                console.log(error);
            }
        },

        async duplica(item) {
            try {
                await this.$store.dispatch("tipiIncasso/duplica", item.id);
            } catch (error) {
                console.log(error);
            }
        },

        etichettaUnita(valore) {
            return (this.unitaDisponibili.find(u => u.value === valore) || {}).label || "";
        },
    },
};
</script>
